import React from 'react';
import { observer } from 'mobx-react';

const Pagination = ({ page = 1, totalPages = 1, onChangePageNumber }) => {
  return (
    <div className="text-[#c3cad5] flex gap-x-[20px] items-center justify-center">
      <button
        // href="#"
        onClick={e => onChangePageNumber(e, 1, true)}
      >
        <i className="icon-paging-first text-[12px]" />
      </button>
      <button
        // href="#"
        onClick={e => onChangePageNumber(e, page - 1 > 1 ? page - 1 : 1, true)}
      >
        <i className="icon-paging-prev text-[12px]" />
      </button>
      {[...Array(totalPages)].map((a, i) => (
        <button
          // href="#"
          onClick={e => onChangePageNumber(e, i + 1, true)}
          className={`font-Pretendard font-bold inline-flex items-center justify-center w-[36px] h-[36px] rounded-full ${
            page === i + 1 ? 'bg-[#822ce5] text-white' : ''
          }`}
          key={`paging_${i + 1}`}
        >
          {i + 1}
        </button>
      ))}
      <button
        // href="#"
        onClick={e =>
          onChangePageNumber(
            e,
            page + 1 <= totalPages ? page + 1 : totalPages,
            true
          )
        }
      >
        <i className="icon-paging-next text-[12px]" />
      </button>
      <button
        // href="#"
        onClick={e => onChangePageNumber(e, totalPages, true)}
      >
        <i className="icon-paging-last text-[12px]" />
      </button>
    </div>
  );
};

export default observer(Pagination);
